import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref, onMounted} from 'vue';
import useCollaboratorState from '@/app/collaborator/infrastructure/persistence/CollaboratorState';
import useProviderState from '@/app/provider/infrastructure/persistence/ProviderState';
import { computed } from '@vue/reactivity';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputProvidersAndCollaborators',
  props: ['modelValue'],
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;

const collaboratorState = useCollaboratorState();
const providerState = useProviderState();



const selected = computed(() => {
    return options.value.filter((option: any) => {
        return option.id == props.modelValue;
    });
});

const options = ref([]);

onMounted(async () => {
    const collaborators = await collaboratorState.getAllSimple();
    const providers = await providerState.getAllSimple();
    const result: any = [];

    collaborators.forEach((collaborator: any) => {
        result.push({
            id: `collaborator-${collaborator.id}`,
            name: collaborator.name,
        });
    });

    providers.forEach((provider: any) => {
        result.push({
            id: `provider-${provider.id}`,
            name: provider.name,
        });
    });

    options.value = result;
});

return (_ctx: any,_cache: any) => {
  const _component_v_combobox = _resolveComponent("v-combobox")!

  return (_openBlock(), _createBlock(_component_v_combobox, {
    "model-value": _unref(selected),
    label: "Fornecedores",
    "item-title": "name",
    "item-value": "id",
    "return-object": "",
    items: options.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => emit('update:modelValue', value.id))
  }, null, 8, ["model-value", "items"]))
}
}

})